/* Nested lists, indented once per generation of the tree. */
.list {
  margin: 0;
  padding: 0 0 0 1.25rem;
  border-left: 1px solid var(--border);
  list-style: none;
}

.item {
  padding: 0.25rem 0;
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.item[data-current="true"] > .row {
  font-weight: 600;
}

.link {
  color: var(--text);
}

.link:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.created {
  display: flex;
  gap: 0.375rem;
  color: var(--text-muted);
  font-size: 0.875rem;
}
